import { render, staticRenderFns } from "./Edupeizhi.vue?vue&type=template&id=1a85f474&scoped=true&"
import script from "./Edupeizhi.vue?vue&type=script&lang=js&"
export * from "./Edupeizhi.vue?vue&type=script&lang=js&"
import style0 from "./Edupeizhi.vue?vue&type=style&index=0&id=1a85f474&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a85f474",
  null
  
)

export default component.exports